var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-container"},[_c('div',[_c('vue-lottie',{staticClass:"center-animation",attrs:{"options":_vm.defaultOptions,"height":_vm.height,"width":_vm.width},on:{"animCreated":_vm.handleAnimation}}),_vm._v(" "),_c('span',[_vm._v("Loading...")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e7c6c152","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Loading.vue
// module id = 581
// module chunks = 1